export const flattenObject = <T extends object>(
  nestedMessages: T,
  prefix = '',
) =>
  Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenObject(value, prefixedKey));
    }

    return messages;
  }, {});
